
import { TabStyles } from '@tableau/widgets';

export interface DataPointCircleStyle {
  r: number;
  strokeWidth: number;
  fill: string | undefined;
  stroke?: string | undefined;
}

export const Colors = TabStyles.Colors;
export const SparklineSpacing = TabStyles.Spacing;
export const SparklineTypography = TabStyles.Typography;

// Style properties of the sparkline.
export const LineWidth = 2;
export const LineColor: string | undefined = Colors.F8; // Grey180, closest we have to Grey153
export const BackgroundColor: string | undefined = Colors.F2;

// The number of pixels by which a text should be separated from other elements
export const TextBuffer: number = SparklineSpacing.SmallSpace;

// The amount of padding from the edge of the SVG to the edges of the path. Circles and text
// might occupy this space, so the values must be greater than any of the circles' (r + strokeWidth).
export const DefaultPadding = {
  paddingTop: Number(SparklineSpacing.LargeSpace),
  paddingRight: Number(SparklineSpacing.MediumSpace),
  paddingBottom: Number(SparklineSpacing.LargeSpace),
  paddingLeft: Number(SparklineSpacing.MediumSpace)
};

export const CircleStyleEnd: DataPointCircleStyle = {
  r: 3.5,
  strokeWidth: 0,
  fill: Colors.F8
};

export const CircleStyleMax: DataPointCircleStyle = {
  r: 3,
  strokeWidth: 1,
  fill: Colors.White,
  stroke: Colors.F8
};

export const CircleStyleMin: DataPointCircleStyle = {
  r: 2.5,
  strokeWidth: 0,
  fill: Colors.F8, // Grey180, closest to Grey136
};

export const LabelStyle = {
  fontSize: Number(SparklineTypography.Sizing.Small), // size must be in pixels
  fill: Colors.F8, // Grey180, closest we have to Grey153; SVG text color uses the 'fill' attribute
};

export const svgStyle = {
  display: 'block',
  backgroundColor: BackgroundColor
};
